var utils = require('../../utils')

export default {
  name: 'careman-list',
  data: function () {
    return {
      shopId: '',
      caremanId: null,
      caremanName: '',
      careOfficeId: '',
      careOfficeName: '',
      duplicatedSearch: false,
      utils: utils,
      searchCallbackFlag: false, // 検索結果フラグ
      watchScroll: null,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'careman_name_furigana':    {'state': true,  'order': true},
        'careoffice_name_furigana': {'state': false, 'order': false},
        'mobile':                   {'state': false, 'order': false}
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.caremansSearchParams !== null) {
        this.$store.getters.caremansSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.caremansSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created() {
    var readMore = false
    var ssShopID = window.sessionStorage.getItem('cml-shopID')
    var ssCareOfficeName = window.sessionStorage.getItem('cml-careOfficeName')
    var ssCaremanName = window.sessionStorage.getItem('cml-caremanName')
    var ssSortKey = window.sessionStorage.getItem("cml-sortKey")
    var ssSortStateOrder = window.sessionStorage.getItem("cml-sortStateOrder")
    if (!!ssShopID) {
      if (ssShopID === 'null') {
        this.shopId = null
      } else {
        this.shopId = ssShopID
      }
    } else {
      this.shopId = this.$store.getters.currentShopId
    }
    if (!!ssCareOfficeName) {
      this.careOfficeName = ssCareOfficeName
    }
    if (!!ssCaremanName) {
      this.caremanName = ssCaremanName
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.shops) {
      this.shopSearch()
    }

    if (!utils.isBlank(this.$route.params.careOfficeId)) {
      this.careOfficeId = this.$route.params.careOfficeId
    }
    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#careoffice_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getCareOffices,
      setSearchData:      this.setSearchCareOffice,
      clear:              this.clearCareOfficesAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    careOfficesAutocomplete() {
      return this.$store.getters.careOfficesAutocomplete
    },
    caremans() {
      return this.$store.getters.caremans
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    nextPage() {
      return this.$store.getters.caremansNextPage
    },
    totalCount() {
      return this.$store.getters.caremansTotalCount
    },
    currentPage() {
      return this.$store.getters.caremansCurrentPage
    },
    shops() {
      return this.$store.getters.shops
    },
    hasCareOfficeId() {
      return utils.isPresent(this.$route.params.careOfficeId)
    },
    /** 通知 */
    notify() {
      return this.$store.getters.caremanNotify
    }
  },
  methods: {
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffice: function (id) {
      this.$router.push({ path: '/care_offices/' + id, query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
      this.careOfficeId = null
      this.clearSearchParams()
      this.search(false)
      // オートコンプリートイベント
      utils.autocompleteEvent({
        $:                  $,
        elem:               '#careoffice_name_autocomplete',
        search:             this.search,
        searchParams:       false,
        searchAutocomplete: this.getCareOffices,
        setSearchData:      this.setSearchCareOffice,
        clear:              this.clearCareOfficesAutocomplete,
      })

      // 最下部スクロールイベント
      utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
    },
    goPrev: function () {
      this.$router.push({ path: '/' })
    },
    goNext: function (id) {
      if (utils.isBlank(this.$route.params.careOfficeId)) {
        this.$router.push({ path: '/care_managers/' + id, query:{type: this.$router.currentRoute.query.type} })
      } else {
        // 介護支援事業所指定
        this.$router.push({ path: '/care_managers/' + id + '/' + this.$route.params.careOfficeId, query:{type: this.$router.currentRoute.query.type} })
      }
    },
    goNewEdit: function () {
      if (utils.isBlank(this.$route.params.careOfficeId)) {
        this.$router.push({ path: '/care_managers/edit', query:{type: this.$router.currentRoute.query.type} })
      } else {
        // 介護支援事業所指定
        this.$router.push({ path: '/care_managers/edit/' + this.$route.params.careOfficeId, query: { type: this.$router.currentRoute.query.type } })
      }
    },
    search: function (readMore) {
      var clear = true
      var loadparams = 'true'
      var url = '/caremans'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.caremansSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.caremansSearchParams['scrollHeight']
        this.$store.getters.caremansSearchParams['pageYOffset'] = null
        this.$store.getters.caremansSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        url = this.$store.getters.caremansNextPageLink
        clear = false
        loadparams = 'block'
      } else {
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'type':             'list',
        'shop_id':          this.shopId,
        'careoffice_name':  this.careOfficeName,
        'careman_name':     this.caremanName,
        'duplicate_flag':   this.duplicatedSearch,
        'careoffice_id':    this.careOfficeId,
        'order':            this.orderByString(),
        'orderByStoreData': this.orderByStoreData(),
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      window.sessionStorage.setItem('cml-shopID', this.shopId)
      if (!!this.careOfficeName) {
        window.sessionStorage.setItem('cml-careOfficeName', this.careOfficeName)
      } else {
        window.sessionStorage.removeItem('cml-careOfficeName')
      }
      if (!!this.caremanName) {
        window.sessionStorage.setItem('cml-caremanName', this.caremanName)
      } else {
        window.sessionStorage.removeItem('cml-caremanName')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("cml-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("cml-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("cml-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("cml-sortStateOrder")
      }

      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CAREMAN_SEARCH', { url: url, data: data, clear: clear, loadparams: loadparams, callback: callback})
    },
    clearSearchParams: function () {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.caremanId = null
      this.caremanName = null
      this.careOfficeId = null
      this.careOfficeName = ''
      this.$store.dispatch('CAREMAN_CLEAR', 0)
    },
    /** 介護支援事業所オートコンプリート */
    getCareOffices: function () {
      this.careOfficeId = null
      this.searchCareOffices()
    },
    /** 介護支援事業所オートコンプリート */
    searchCareOffices: function () {
      var clear        = false
      var autocomplete = true
      var send_fails   = 0

      var data = {
        'shop_id':          this.shopId,
        'careoffice_name':  this.careOfficeName,
        'send_fails':       send_fails
      }
      this.$store.dispatch('CARE_OFFICE_SEARCH', { clear: clear, data: data, autocomplete: autocomplete, loadparams: false})
    },
    /** 介護支援事業所オートコンプリート */
    clearCareOfficesAutocomplete: function () {
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 500)
    },
    /** 介護支援事業所オートコンプリート */
    setSearchCareOffice: function (careOfficeId, careOfficeName) {
      this.careOfficeName = careOfficeName
      this.careOfficeId = careOfficeId
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 100)
    },

    /** 電話番号重複 */
    duplicatedTel: function () {
      this.duplicatedSearch = !this.duplicatedSearch
      this.search(false)
    },
    /** 電話番号重複 */
    getDuplicatedTelClass: function (flag) {
      return flag ? 'btn-success' : 'btn-default'
    },
    shopSearch: function () {
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('careman_name_furigana asc')
      }
      return result.join(' , ')
    },
    /** ストアに保存するソート取得 */
    orderByStoreData: function() {
      var key = null
      var state = null
      var order = null
      for (var k in this.sortState) {
        if (this.sortState[k].state) {
          key = k
          order = false
          if (this.sortState[k].order) {
            order = true
          }
        }
      }
      if (key === null) {
        // 存在しない場合
        key = 'careman_name_furigana'
        order = true
      }
      return {key: key, order: order}
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/careman-list.js